//Built-In
import React, {Fragment} from 'react';

//External
import { Col, Row} from "react-bootstrap";
import Select from "react-select";
import { Button, InputGroup } from "reactstrap";
import cx from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons/faCalendarAlt";

//Internal
import Common from "../../Common/Common";
import setMinutes from 'date-fns/setMinutes';
import setHours from 'date-fns/setHours';
import CommonHeaderContent from "../../Common/CommonHeaderContent";
import {
    decodeString, formatDate, getFormInformation,
    getFormDetails, getTemplateInfo, getWAComponents,
    parseJSON, populateFormDetails, showToast, getSessionValue,
    handleErrorResponse, confirmBoxWithImage,validateRestrictedActions,
    uploadFileIntoS3,
    isMobile,getFormNameandLabel,
    getTemplateQualityById,
    confirmBox,
    getRefTemplateValues
} from "../../Common/Appcommon";
import {setFormDetails} from "../../reducers/ThemeOptions";
import requestApi from "../../services/requestApi.service";
import PreviewPanel from "../WhatsappComponents/PreviewPanel";
import WhatsappComponent from "../../Common/WhatsappComponent";
import {faPaperPlane} from "@fortawesome/free-regular-svg-icons/faPaperPlane";
import campaignSend from "../../assets/utils/images/campaign_send.png";
import {Controller} from "react-hook-form";

class CampaignOperations extends React.Component{
    formname = process.env.REACT_APP_CAMPAIGN_FORMNAME;
    templateFormname = process.env.REACT_APP_TEMPLATES_FORMNAME;
    templateFormDetail = [];
    leadFormname = getSessionValue('leadformname');
    contactFormname = process.env.REACT_APP_CONTACT_FORMNAME;
    leadFormDetail = [];
    buttonClickRef = React.createRef();
    constructor(props) {
        super(props);
        let campaignId = props.match === undefined || props.match.params.id === undefined ? '' : props.match.params.id;
        if(props.isModal && props.campaignId !== ""){
            campaignId = props.campaignId;
        }

        this.state = {
            waTemplates : {},
            waOptions : [],
            selectedTemplate : [],
            leadSelectedTemplate : [],
            components : [],
            waComponents : {},
            formList : [],
            selectedForm : [],
            leadTemplates : [],
            formData : {},
            previewData : {},
            campaignId : campaignId,
            scheduleDate: '',
            showLoader : false,
            errors : {},
            isSendSetLive : false,
            defaultValues : {},
            isrequestsent : false,
        }
        this.handleDatePickerChange = this.handleDatePickerChange.bind(this);
        //this.buttonClickRef = React.createRef();
    }

    componentDidMount = async() => {
        this.setState({
            showLoader : true
        })

        let { campaignId } = this.state;

        if(this.props.selectedFormName !== undefined && this.props.selectedFormName !== null && this.props.selectedFormName !== ''){
            await this.getLeadAndTemplateDetails(this.props.selectedFormName);
        }else{
            await this.getLeadAndTemplateDetails();
        }

        await this.getFormNameByMobileNo();

        if(campaignId !== ""){
            let formResponse = await getFormInformation(campaignId, this.formname);
            if(formResponse.issuccess){
                let recordData = formResponse.data;
                await this.prepareFormEditData(recordData);
            } else if (formResponse.errormsg !== ""){
                showToast(formResponse.errormsg,"top-right","error");
            }
        }

        this.setState({
            showLoader : false
        })
    }

    getLeadAndTemplateDetails = async (formname = this.leadFormname) => {
        if(this.props.isInbox){
            formname = this.contactFormname;
        }
        this.templateFormDetail = await this.populateFormDetail(this.templateFormname);
        this.leadFormDetail = await this.populateFormDetail(formname);

        let templates = this.leadFormDetail[4] !== undefined ? this.leadFormDetail[4] : [];
        this.setState({
            leadTemplates : templates
        })
        await this.getTemplateDetails();
    }

    getFormNameByMobileNo = async () => {

        let isEnabledList = {
            "isAddonEnabled" : true, 
            "isWsappEnabled" : true, 
            "isProfileEnabled" : true,
            "type" : "Campaign",
            "isContactRef" : true
        };

        let response = await getFormNameandLabel(isEnabledList);

        if(response.issuccess){
            let data = response.data;
            this.setState({
                formList : data
            })
        }
    }


    prepareFormEditData = async (data) =>{
        let formInputData = {};
        let selectedTemplate = {};
        let leadSelectedTemplate = {};
        let otherComponents = {};
        let components = [];
        let waComponents = {};
        let scheduleDate = "";
        let defaultValues = {};
        if(data !== undefined && Object.keys(data).length > 0){
            for(let key in data){
                if(key === "Name"){
                    formInputData["campaign"] = data[key];
                } else if (key === "Template"){
                    let templateInfo = data[key];
                    selectedTemplate = await getTemplateInfo(templateInfo);
                    formInputData["wa_template"] = templateInfo;
                    let template = this.state.waTemplates[selectedTemplate.value];
                    if(template !== undefined && template !== null) {
                        components = parseJSON(decodeString(template['Components']));
                        waComponents = getWAComponents(components);
                    }
                } else if (key === "Components"){
                    otherComponents = parseJSON(data['Components']);
                } else if (key === "Lead_Template"){
                    let templateInfo = data[key];
                    let tempateInfosplit = templateInfo.split("#");
                    let selectedFormname = tempateInfosplit[2] !== undefined ? tempateInfosplit[2] : this.leadFormname;
                    if(selectedFormname !== ''){
                        if(this.state.formList !== undefined && this.state.formList !== ''){
                            this.state.formList.map((val) => {
                                if(val.value == selectedFormname){
                                    if(this.props.automationId == undefined){
                                        this.getLeadAndTemplateDetails(selectedFormname);
                                    }
                                    this.setState({
                                        selectedForm : val
                                    })
                                }
                            })
                        }
                    }
                    leadSelectedTemplate = await getTemplateInfo(templateInfo);
                    formInputData["lead_template"] = templateInfo;

                } else if (key === "Schedule_Type"){
                    formInputData["schedule"] = data[key];
                } else if (key === "Schedule_Time"){
                    formInputData["scheduleTime"] = data[key];
                    if(data[key] !== "" && data[key] !== null) {
                        scheduleDate = new Date(data[key]+"Z");
                        formInputData["scheduleTime"] = formatDate(scheduleDate);
                    }
                } else if (key === "Media_Type"){
                    formInputData["mediatype"] = data[key];
                } else if (key === "Status"){
                    formInputData["Status"] = data[key];
                }
            }
        }
        let header = otherComponents['header'];
        formInputData['mediaUrl'] = header['mediaUrl'] !== undefined ? header['mediaUrl'] : '';
        let headerVariables = header['variables'] !== undefined ? header['variables'] : {};
        let body = otherComponents['body'];
        let variables = body['variables'];
        let previewData = {};
        for(let v = 0; v < variables.length; v++){
            let variableSelect = variables[v];
            let vIndex = v + 1;
            let tmpSelect = {
                value : variableSelect.value,
                label : variableSelect.label,
                fieldType : variableSelect.fieldType
            }
            let objName = "body_variable_field_"+vIndex;
            previewData[objName] = variableSelect.value;
            previewData[objName+"_label"] = variableSelect.label;
            formInputData[objName+"_selected"] = this.props.resetAllCampVariables !== undefined && this.props.resetAllCampVariables ? {} : tmpSelect;
            formInputData["body_df_value_field_"+vIndex] =  this.props.resetAllCampVariables !== undefined && this.props.resetAllCampVariables ? '' : variableSelect.defaultvalue;
        }
        if(Object.keys(headerVariables).length > 0){
            let tmpHeaderSelect = {
                value : headerVariables.value,
                label : headerVariables.label,
                fieldType : headerVariables.fieldType
            }
            let objName = "header_variable_1";
            previewData[objName] = headerVariables.value;
            previewData[objName+"_label"] = headerVariables.label;
            formInputData[objName+"_selected"] = tmpHeaderSelect;
            if(headerVariables.defaultvalue !== undefined && headerVariables.defaultvalue !== ""){
                formInputData["header_df_value_field_1"] = headerVariables.defaultvalue;
            }
        }
        if(otherComponents){
            Object.keys(otherComponents).forEach(key => {
                if(key.startsWith('carousel_card_')){
                    formInputData[key] = otherComponents[key];
                }
            });
        }

        this.setState({
            formData : formInputData,
            previewData : previewData,
            selectedTemplate, leadSelectedTemplate , components, waComponents,scheduleDate
        });
    }

    populateFormDetail = async(formname) => {
        let formDetail = await getFormDetails(formname,this.props['formDetails']);
        if(formDetail.length === 0){
            formDetail = await populateFormDetails(formname);
            let newFormDetails = {};
            newFormDetails[formname] = formDetail;
            await setFormDetails([newFormDetails]);
        }
        return formDetail;
    }

    handleInputChange = async(e) => {
        let name = e.target.name;
        let formInputData = this.state.formData;
        formInputData[name] = e.target.value;
        this.setState({
            formData: formInputData
        })
    }

    getTemplateDetails = async() =>{
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "Get_Templates",
            "FORMNAME": this.templateFormname,
            "isOtherApiReq" : true,
        }
        let templateResponse = await requestApi.processServerRequest(params, "WebV2");
        if(templateResponse.issuccess) {
            let templates = templateResponse.data;
            let waTemplates = {};
            let waOptions = [];
            templates.forEach((template, index) => {
                waTemplates[template['Template_ID']] = template;
                waOptions.push({
                    value: template['Template_ID'], label: template['Name']
                })
            });
            this.setState({
                waTemplates, waOptions
            })
        } else if (templateResponse.errormsg != ""){
            showToast(templateResponse.errormsg, "top-right","error");
        }
    }

    saveCampaignInfo = async() => {
        await this.buttonClickRef.current.click();
    }

    validate = async (values) => {
        let errors = {};
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        /*if (!values.campaign) {
            errors.campaign = "Email is required";
        } else if (!regex.test(values.campaign)) {
            errors.campaign = "Invalid Email";
        }

        if (!values.templates) {
            errors.templates = "Password is required";
        }*/

        return errors;
    };

    onFileUpload = async (e, index=null, type=null) => {
        // Use a temporary object for carousel uploads to avoid overwriting global mediaUrl
        let uploadContext = type === 'carousel' ? {} : this.state.formData;
        let {resetInput, formInputData} = await uploadFileIntoS3(e, uploadContext);

        let newErrors = { ...this.state.errors };

        if (type === 'carousel' && index !== null) {
            let newFormData = { ...this.state.formData };
            newFormData[`carousel_card_${index}_mediaUrl`] = formInputData.mediaUrl;
            newFormData[`carousel_card_${index}_mediaType`] = formInputData.mediaType;
            newFormData[`carousel_card_${index}_mediaHandle`] = formInputData.media_handle;
            
            // Clear error for this card
            let errorKey = `carousel_card_${index}_mediaUrl`;
            if(newErrors[errorKey]) delete newErrors[errorKey];

            this.setState({
                formData: newFormData,
                errors: newErrors
            });
        } else {
            // Clear general mediaUrl error
            if(newErrors['mediaUrl']) delete newErrors['mediaUrl'];
            
            this.setState({
                formData: formInputData,
                errors: newErrors
            });
        }

        //Reset file input value. since something went wrong
        if(resetInput){
            e.target.value = null;
        }
    }

    validateFormData = async(e) => {
        let { formData, selectedTemplate, waTemplates, waComponents, components, campaignId, errors } = this.state;
        let isValidSave = true;
        
        // Validate Header Media
        if(waComponents['HEADER'] !== undefined && waComponents['HEADER']['format'] !== "TEXT"){
            let mediaUrl = formData['mediaUrl'];
            if(mediaUrl === undefined || mediaUrl === ""){
                errors['mediaUrl'] = "Media file not selected";
                isValidSave = false;
            }
        }
        
        // Validate Carousel Cards Media
        if(waComponents['CAROUSEL'] !== undefined && waComponents['CAROUSEL']['cards'] !== undefined){
            let cards = waComponents['CAROUSEL']['cards'];
            cards.forEach((card, index) => {
                 let header = card.components ? card.components.find(c => c.type === 'HEADER') : null;
                 let format = header ? header.format : 'TEXT';
                 if(format === 'IMAGE' || format === 'VIDEO'){
                     let mediaKey = `carousel_card_${index}_mediaUrl`;
                     if(!formData[mediaKey] || formData[mediaKey] === ""){
                         errors[mediaKey] = "Add Media file";
                         isValidSave = false;
                     }
                 }
            });
        }

        await this.setState({
            errors
        })
        return isValidSave;
    }

    submitForm = async (data) => {
        if(!this.state.isrequestsent){
            const {reset } = this.props.useForm;
            //e.preventDefault();
            let { formData, selectedTemplate, waTemplates, waComponents, components, campaignId, errors, scheduleDate, isSendSetLive } = this.state;
            let { isInbox, leadInfo, isModal } = this.props;
            let res = {};
            let params = {};
            let valid = await validateRestrictedActions();
            if(!valid){
                return false;
            }
            let isValidSave = await this.validateFormData();
            if(isValidSave){
                this.setState({
                    isrequestsent : true
                })
            }

            //Perform campaign related operations on submit
            if(!isInbox){
                if(isValidSave) {
                    let campaignType = "Campaign";
                    let automation = "";
                    if (isModal) {
                        campaignType = "Automation";
                        automation = this.props.automationId;
                    }
                    if(!isModal){
                        //update current date when user scheduled but not changed default scheduled time.
                        if(formData['schedule'] === 'later'){
                            if(formData["scheduleTime"] === undefined || formData["scheduleTime"] === "" || formData["scheduleTime"] === null){
                                let scheduledDate = (scheduleDate !== undefined && scheduleDate !== "") ? scheduleDate : new Date();
                                formData["scheduleTime"] = formatDate(scheduledDate);
                            }
                        }
                    }
                    formData['campaignType'] = campaignType;
                    formData['mediatype'] = "upload";
                    formData['automation'] = automation;
                    formData['Status'] = 'Draft';//isSendSetLive == false ? 'Draft' : "Progress";
                    params = {
                        "ENTITY": "WHATSAPPPROCESS",
                        "FORMINPUT": formData,
                        "WACOMPONENTS": waComponents,
                        "COMPONENTS": components,
                        "isOtherApiReq": true,
                        "FORMNAME": this.formname
                    }
                    if (campaignId === "") {
                        params["OPERATION"] = "SAVE";
                    } else if (campaignId !== "") {
                        params["OPERATION"] = "UPDATE";
                        params["FORMID"] = campaignId;
                    }

                    res = await requestApi.processServerRequest(params, "WebV2", "post");
                }
                //Perform Template message send operations on submit
            }else{
                if(isValidSave) {
                    if(Object.keys(leadInfo).length > 0 && Object.keys(selectedTemplate).length > 0){

                        let selectedTemplateId = selectedTemplate.value;
                        let language = '';
                        if(waTemplates[selectedTemplateId] !== undefined && waTemplates[selectedTemplateId].Language !== undefined){
                            language = waTemplates[selectedTemplateId].Language;
                        }

                        if(language !== ''){
                            params = {
                                "ENTITY": "WHATSAPPPROCESS",
                                "OPERATION": "SEND_WHATSAPP_TEMPLATE_MSG",
                                "FORMINPUT" : formData,
                                "WACOMPONENTS" : waComponents,
                                "COMPONENTS" : components,
                                "TEMPLATE_NAME" : selectedTemplate.label,
                                "TEMPLATE_ID" : selectedTemplateId,
                                "LANGUGAE" : language,
                                "isOtherApiReq" : true,
                                "FORMNAME" : this.formname,
                                "CONTACTID" : leadInfo[`${this.contactFormname}_id`]
                            }

                            res = await requestApi.processServerRequest(params,"WebV2","post");
                        }
                    }
                } else {
                    // showToast("Media file not selected","top-right","warning");
                    return false;
                }
            }

            if(res.issuccess) {
                let resData = res.data;
                if (isModal) {
                    if(isInbox){
                        await this.props.campaignSaveOperation(resData);
                    }else{
                        if(formData['campaignType'] !== undefined && formData['campaignType'] === "Automation"){
                            this.props.handleCampaignChanged(resData[0]);
                        }
                        await this.props.campaignSaveOperation(resData[0]);
                    }
                } else {
                    this.setState({
                        campaignId : resData[0]
                    })
                    if(!this.state.isSendSetLive) {
                        this.props.history.push('/campaigns');
                    } else {
                        const scheduled = await this.scheduleTheCampaign(resData[0], formData);
                        if(scheduled){
                            this.props.history.push('/campaigns');
                        }else{
                            //this.props.history.push(`/campaign/edit/${resData[0]}`);
                        }
                        this.setState({
                            isSendSetLive : false
                        })
                    }
                }
            } else if (res.errormsg !== ""){
                showToast(res.errormsg,"top-right","error");
            }
            this.setState({
                isrequestsent : false
            })
            reset({
                waComponents : '',
                components : ''
            });
            return false;
        }
    };

    handleDatePickerChange = async(date) => {
        let scheduledDateTime = formatDate(date);
        let formInputData = this.state.formData;
        if(date === null){
            formInputData["scheduleTime"] = '';
            this.setState({
                scheduleDate : '',
                formData: formInputData
            });
        }else{
            formInputData["scheduleTime"] = scheduledDateTime;
            this.setState({
                scheduleDate : date,
                formData: formInputData
            });
        }
    }

    resetVariables = async (formInputData = this.state.formData) => {
        const filteredSelKeys = Object.keys(formInputData).filter(key => key.includes('body_variable_field_'));
        const filteredDFKeys = Object.keys(formInputData).filter(key => key.includes('body_df_value_field_'));

        let selected_value = 1;
        let df_value = 1;

        for(let i = 0; i < Object.keys(formInputData).length; i++){
            if(filteredSelKeys[i] !== undefined && filteredSelKeys[i].includes('body_variable_field_')){
                let k = 'body_variable_field_'+ selected_value +"_selected";
                formInputData[k] = {};
                selected_value++;
            }
            if(filteredDFKeys[i] !== undefined && filteredDFKeys[i].includes('body_df_value_field_')){
                let k = 'body_df_value_field_'+ df_value;
                formInputData[k] = '';
                df_value++;
            }
        }

        this.setState({
            formData : formInputData
        });
    }

    handleTemplateChange = async (selectedTemplate, objName) => {
        let templateId = selectedTemplate.value;
        let { inbox, leadInfo } = this.props;
        //let refInfo = "-";
        // if(objName.includes('body_variable_field_')){
        //     if(selectedTemplate.label.includes('USER::')){
        //     //refInfo = await getRefTemplateValues(selectedTemplate,leadInfo);
        //     }
        // }

        if(objName === "wa_template") {
            let quality_score = await getTemplateQualityById(templateId);
            if(quality_score == "RED"){
                let title = "The quality of this template is low";
                let message = `The template's quality is in the ${quality_score} zone. There is a high risk that the message might not be delivered properly.`;
                let confirm = await confirmBox(title, message, "error");
                if(!confirm){
                    return;
                }
            }else if(quality_score == "YELLOW"){
                let title = "The quality of this template is MEDIUM";
                let message = `The template's quality is in the ${quality_score} zone. There is a high risk that the message might not be delivered properly.`;
                let confirm = await confirmBox(title, message);
                if(!confirm){
                    return;
                }
            }
            let template = this.state.waTemplates[templateId];
            let components = parseJSON(decodeString(template['Components']));
            let waComponents = getWAComponents(components);
            if(isMobile() && waComponents['HEADER'] !== undefined && waComponents['HEADER']['format'] !== "TEXT"){
                showToast("Only Text messages are supported.");
                return;
            }
            let formData = this.state.formData;
            formData[objName] = selectedTemplate.value+"#"+selectedTemplate.label;
            formData['mediaUrl'] = "";
            formData['fileName'] = "";
            formData['mediaType'] = "";
            if(template['media_info'] !== undefined && template['media_info'] !== null && template['media_info'] !== ""){
                let mediaInfo = JSON.parse(template['media_info']);
                formData['mediaUrl'] = mediaInfo.mediaUrl;
                formData['fileName'] = mediaInfo.fileName;
                formData['mediaType'] = mediaInfo.mediaType;
            }
            
            await this.setState({
                selectedTemplate, components, waComponents, formData
            })
        } else if (objName === "lead_template"){
            let formData = this.state.formData;
            let formname = this.state.selectedForm.value !== undefined ? this.state.selectedForm.value : '';
            formData[objName] = selectedTemplate.value+"#"+selectedTemplate.label+"#"+formname;
            this.setState({
                leadSelectedTemplate : selectedTemplate, formData
            })
        } else if (objName === "selected_form"){
            if(this.state.selectedForm !== undefined && this.state.selectedForm !== selectedTemplate){
                
                this.setState({
                    selectedForm : selectedTemplate,
                    leadSelectedTemplate : []
                });

                if(this.state.selectedForm.value !== selectedTemplate.value){
                    this.resetVariables();
                }

                if(selectedTemplate.value !== undefined && selectedTemplate.value !== null && selectedTemplate.value !== '' ){
                    await this.getLeadAndTemplateDetails(selectedTemplate.value);
                }
            }
        } else if(objName.includes('body_variable_field_') || objName.includes('header_variable')){
            let formInputData = this.state.formData;
            let previewData = this.state.previewData;
            previewData[objName] = selectedTemplate.value;
            previewData[objName+"_label"] = selectedTemplate.label;
            formInputData[objName+"_selected"] = selectedTemplate;
            let lastIndex = objName.lastIndexOf('_');
            let modified = false;
            if(leadInfo !== undefined){
                let label = selectedTemplate.label === 'Form ID' ? `${this.contactFormname}_id` : selectedTemplate.value;
                if(selectedTemplate.label.includes("USER::")){
                    if(!leadInfo[label]){
                        label = "USER::"+label;
                    }
                }
                if(leadInfo[label]){
                    if(lastIndex !== -1){
                        let index = objName.slice(lastIndex + 1);
                        if(objName.includes('body_variable_field_')) {
                            if(selectedTemplate.fieldType === 'entity_group'){
                                formInputData["body_df_lead_value_field_" + index] = await this.getAssignToName(leadInfo[label]);
                            }else{ 
                                formInputData["body_df_lead_value_field_" + index] = leadInfo[label];
                            }                           
                            modified = true;
                        } else if (objName.includes('header_variable_1')){
                            formInputData["header_df_lead_value_field_1"] = leadInfo[label];
                            modified = true;
                        }
                    }
                }
                // else if(refInfo !== "-" && selectedTemplate.label.includes('USER::')){
                //         if(lastIndex !== -1){
                //         let index = objName.slice(lastIndex + 1);
                //         if(objName.includes('body_variable_field_')) {
                //             if(selectedTemplate.fieldType === 'entity_group'){
                //                 formInputData["body_df_lead_value_field_" + index] = await this.getAssignToName(refInfo);
                //             }else{ 
                //                 formInputData["body_df_lead_value_field_" + index] = refInfo;
                //             }                           
                //             modified = true;
                //         } else if (objName.includes('header_variable_1')){
                //             formInputData["header_df_lead_value_field_1"] = refInfo;
                //             modified = true;
                //         }
                //     }
                // }
            }

            if(!modified){
                //Delete previous default value. when new variable is applied but its value is empty.
                if(lastIndex !== -1){
                    let index = objName.slice(lastIndex + 1);
                    if(objName.includes('body_variable_field_') && formInputData["body_df_lead_value_field_" + index]){
                        delete formInputData["body_df_lead_value_field_" + index];
                    }else if(objName.includes('header_variable_1') && formInputData["header_df_lead_value_field_1"]){
                        delete formInputData["header_df_lead_value_field_1"];
                    }
                }
            }
            this.setState({
                formData: formInputData,
                previewData : previewData
            });
        }
    }

    getTotalLeadInfo = async (campaignId) => {
        let totalLead = 0;
        if(campaignId !== "") {
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "LEAD_INFO",
                "campaignId": campaignId,
                "isOtherApiReq": true,
                "FORMNAME": this.formname
            }

            let res = await requestApi.processServerRequest(params, "WebV2", "post");
            if (res.issuccess) {
                totalLead = res.data;
            }else{
                this.setState({
                    isrequestsent : false,
                })
            }
        }
        return totalLead;
    }

    getAssignToName = async (userId) => {
        let username = userId;
        if(userId !== "") {
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "GET_ASSIGNTO_NAME",
                "userId": userId,
                "isOtherApiReq": true,
                "FORMNAME": this.formname
            }

            let res = await requestApi.processServerRequest(params, "WebV2", "post");
            if (res.issuccess) {               
                username = res.data;
            }
        }
        return username;
    }

    scheduleTheCampaign = async (campaignId, formData) => {

        let scheduled = true;

        if(campaignId !== "") {
           let leadCountInfo = await this.getTotalLeadInfo(campaignId);
            let leadCount = parseInt(leadCountInfo[0]);
            let tier = 1000;
            if(leadCountInfo[1].length > 0){
                //let status = leadCountInfo[1][0][0];
                tier = leadCountInfo[1][0][1];
            }
            //let score = leadCountInfo[1][0][2];
            //let usedCount = leadCountInfo[1][1][0];
           // if(usedCount == ''){
                //usedCount = 0;
           // }
           //let balcount = tier - usedCount;
            let title = "You are ready to go!";
            let message = "You have " + leadCount + " recipient(s) to send this message currently, but once you set live it will send to the recipient(s) who meets the audience condition.";
            let imageIcon = campaignSend;
            if (leadCount === 0) {
                title = "The estimated recipient count is zero.";
                message = "You must include at least one active recipient to send or schedule this campaign.";
                imageIcon = "";
            }else if(tier != "UL" && leadCount > tier && tier != undefined){
                title = "The estimated recipient count("+leadCount+") is greater than your daily tier limit("+tier+").";
                message = "You cant send or schedule this campaign.";
                imageIcon = "";
            }
            let isConfirm = await confirmBoxWithImage(title, message, imageIcon);
            if (isConfirm && leadCount > 0 && (leadCount <= tier || tier == 'UL') && tier != undefined) {
                let params = {
                    "ENTITY": "WHATSAPPPROCESS",
                    "OPERATION": "SENDCAMPAIGN",
                    "campaignId": campaignId,
                    "isOtherApiReq": true,
                    "FORMNAME": this.formname,
                    "leadCount" : leadCount,
                    'Status' : (formData['schedule'] !== undefined && formData['schedule'] === 'later') ? 'Scheduled' : 'Progress',
                }

                this.setState({
                    showLoader : true
                })
                let res = await requestApi.processServerRequest(params, "WebV2", "post");
                this.setState({
                    showLoader : false
                })
                if (!res.issuccess) {
                    handleErrorResponse(res.errormsg);
                } else {
                    let status = leadCount <= 10 ? "Send" : "Scheduled";
                    showToast('Campaign '+status+' successfully!', 'top-right', 'success');
                }
            }else{
                if(leadCount > tier){
                    showToast("Lead Count Bigger then Your Whatsapp Limitation","top-right", "warning")
                }
                scheduled = false;
                this.setState({
                    isrequestsent : false,
                })
            }
        
        }

        return scheduled;
    }

    sendCampaign = async () => {
        let valid = await validateRestrictedActions();
        if(!valid){
            return false;
        }
        await this.setState({
            isSendSetLive : true
        })
        await this.saveCampaignInfo();

    }


    getCampaignOperationsContent = () => {

        let { waTemplates, waOptions, components, waComponents, leadTemplates, campaignId } = this.state;
        let { isInbox, controller } = this.props;
        let {isModal}=this.props;

        if(isInbox === undefined){
            isInbox = false;
        }
        const { register, handleSubmit,control, formState: { errors } } = this.props.useForm;
        let leadTemplateOptions = [];
        leadTemplates.forEach((template,index)=> {
            if(template[11] == 1) {
                leadTemplateOptions.push({
                    value: template[0], label: template[1]
                })
            }
        });

        let buttonTxt = "Create Campaign";
        if(this.props.isModal){
            if(isInbox){
                buttonTxt = "Send Message";
            }else{
                buttonTxt = campaignId === "" ? "Create Message" : "Update Message";
            }
        } else if (campaignId !== "" && !this.props.isModal){
            buttonTxt = "Update Campaign";
        }

        let campaignErrorMsg = this.props.isModal ? 'Please provide a message name' : 'Please provide a campaign name';
        return (
            <Fragment>
                <div className={cx('newcampaign-panel overflow-scroll',{'overflow-scroll min-height-2' : this.props.isModal,'inbox-modal' : this.props.isInbox})} >
                    <Row className={''}>
                        <Col md={'8'} className={''}>
                            <div className="container">
                                <form name={'campaign'} onSubmit={handleSubmit(this.submitForm)}>
                                    <div className={cx('mt-3',{'vertical-timeline-without-image' : !isInbox})}>
                                        <Row className={'automation-section'}>
                                            <div className={cx('group-header',{
                                                'hide' : isInbox,
                                                'group-header-flex' : !isInbox,
                                            })}>
                                                <div className={'automation-stepnumber'}>
                                                    1
                                                </div>
                                                <span> Provide a {this.props.isModal ? 'message' : 'campaign'} name</span>
                                            </div>
                                            <Col md="10" className={cx('pr-0 d-grid margin-left-3',{
                                                'hide' : isInbox,

                                            })}>
                                                <label className={'group-header-lbl'} htmlFor="campaign">{this.props.isModal ? 'Message Name' : 'Campaign Name'}</label>
                                                <Controller
                                                    name="campaign"
                                                    control={control}
                                                    rules={{ required: !isInbox && (this.state.formData.campaign === "" || this.state.formData.campaign === undefined) ? campaignErrorMsg : false}}
                                                    render={({ field }) => {
                                                        return (
                                                            <input
                                                                {...field}
                                                                type="text"
                                                                name="campaign"
                                                                id="campaign-name"
                                                                value={this.state.formData.campaign}
                                                                autoComplete={"off"}
                                                                onChange={(e) => {
                                                                    this.handleInputChange(e)
                                                                    field.onChange(e);
                                                                }}
                                                                className={`form-control ${errors.campaign ? 'is-invalid' : ''}`}
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors.campaign && <em className={`error invalid-feedback`}>{errors.campaign.message}</em>}
                                            </Col>
                                        </Row>
                                        <Row className={cx('automation-section',{'hide' : this.props.isModal})}>
                                            <div className={'group-header group-header-flex'}>
                                                <div className={'automation-stepnumber'}>
                                                    2
                                                </div>
                                                <span> Who will receive this campaign</span>
                                            </div>
                                            <Col md={'10'} className={'pr-0 d-grid mt-2 margin-left-3'}>
                                                <label className={'group-header-lbl'} htmlFor="selected_form">Choose a Module </label>
                                                <Controller
                                                    name="selected_form"
                                                    control={control}
                                                    rules={{ required: !isInbox && !this.props.isModal && this.state.selectedForm.length === 0 ?  "Please choose a module" : false}}
                                                    render={({ field }) => {
                                                        return (
                                                            <Select
                                                                {...field}
                                                                menuPlacement={"auto"}
                                                                menuPosition={'fixed'}
                                                                required={false}
                                                                name="selected_form"
                                                                id="selected_form"
                                                                value={Object.keys(this.state.formList).length === 0 ? false : this.state.selectedForm}
                                                                onChange={(e) => {
                                                                    this.handleTemplateChange(e,'selected_form')
                                                                    field.onChange(e)
                                                                }}
                                                                options={this.state.formList}
                                                                className={`basic-multi-select ${errors.selected_form ? 'is-invalid' : ''}`}
                                                                classNamePrefix="wa-select"
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors.selected_form && <em className={`error invalid-feedback`}>{errors.selected_form.message}</em>}
                                            </Col>
                                            <Col md={'10'} className={'pr-0 d-grid mt-2 margin-left-3'}>
                                                <label className={'group-header-lbl'} htmlFor="lead_templates">Recipients Segment</label>
                                                <Controller
                                                    name="lead_templates"
                                                    control={control}
                                                    rules={{ required: !isInbox && !this.props.isModal && this.state.leadSelectedTemplate.length === 0 ?  "Please choose a segment" : false}}
                                                    render={({ field }) => {
                                                        return (
                                                            <Select
                                                                {...field}
                                                                menuPlacement={"auto"}
                                                                menuPosition={'fixed'}
                                                                required={false}
                                                                name="lead_templates"
                                                                id="lead_templates"
                                                                value={Object.keys(leadTemplateOptions).length === 0 ? false : this.state.leadSelectedTemplate}
                                                                onChange={(e) => {
                                                                    this.handleTemplateChange(e,'lead_template')
                                                                    field.onChange(e);
                                                                }}
                                                                options={leadTemplateOptions}
                                                                className={`basic-multi-select ${errors.lead_templates ? 'is-invalid' : ''}`}
                                                                classNamePrefix="wa-select"
                                                                isDisabled = {this.state.selectedForm == '' ? true : false}
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors.lead_templates && <em className={`error invalid-feedback`}>{errors.lead_templates.message}</em>}
                                            </Col>
                                        </Row>
                                        <Row className={'automation-section'}>
                                            <div className={cx('group-header group-header-flex',{
                                                '' : isInbox,
                                                'group-header-flex' : !isInbox
                                            })}>
                                                <div className={'automation-stepnumber'}>
                                                    {isInbox ? 1 : isModal ? 2 : 3}
                                                </div>
                                                <span> Choose a template</span>
                                            </div>
                                            <Col md={isInbox ? "10" : "10" } className={'pr-0 d-grid margin-left-3'}>
                                                <label className={'group-header-lbl'} htmlFor="templates">{ isInbox ? 'Templates' : 'Templates'}</label>
                                                <Controller
                                                    name="wa_template"
                                                    control={control}
                                                    rules={{ required: this.state.selectedTemplate.length === 0 ? "Please choose a template" : false }}
                                                    render={({ field }) => {
                                                        return (
                                                            <Select
                                                                {...field}
                                                                menuPlacement={"auto"}
                                                                menuPosition={'fixed'}
                                                                name="templates"
                                                                id="templates"
                                                                value={this.state.selectedTemplate}
                                                                onChange={e => {
                                                                    this.handleTemplateChange(e,'wa_template');
                                                                    field.onChange(e);
                                                                }}
                                                                options={waOptions}
                                                                className={`basic-multi-select ${errors.wa_template ? 'is-invalid' : ''}`}
                                                                classNamePrefix="wa-select"
                                                                isDisabled = { 
                                                                    this.props.automationId == undefined &&
                                                                    !isInbox && 
                                                                    this.state.leadSelectedTemplate == '' ? true : false
                                                                }
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors.wa_template && <em className={`error invalid-feedback`}>{errors.wa_template.message}</em>}
                                            </Col>
                                            <div className={'margin-left-3'}>
                                                <WhatsappComponent
                                                    form={this.props.useForm}
                                                    controller={controller}
                                                    errors={this.state.errors}
                                                    waComponents={waComponents}
                                                    handleInputChange={this.handleInputChange}
                                                    onFileUpload={this.onFileUpload}
                                                    handleTemplateChange={this.handleTemplateChange}
                                                    previewData={this.state.previewData}
                                                    leadFormDetail={this.leadFormDetail}
                                                    formData={this.state.formData}
                                                />
                                            </div>

                                        </Row>
                                        
                                        <Row className={cx('automation-section',{'hide' : this.props.isModal})}>
                                            <div className={'group-header group-header-flex'}>
                                                <div className={'automation-stepnumber'}>
                                                    4
                                                </div>
                                                <span> Schedule your campaign</span>
                                            </div>
                                            <Col md={'7'} className={'pr-0 d-grid mt-3 margin-left-3'}>
                                                <label className={'group-header-lbl'} htmlFor="camp_schedule">Schedule Campaign</label>
                                                <div className={'flex-center-v'} onChange={(event => {this.handleInputChange(event)})}>
                                                    <input type="radio" value="immediate" checked={this.state.formData['schedule'] == undefined || this.state.formData['schedule'] == 'immediate'} name="schedule" /> <span className={'ml-1'}> Send Immediately</span>
                                                    <input type="radio" className={'ml-1'} value="later" checked={this.state.formData['schedule'] == 'later'} name="schedule" /> <span className={'ml-1'}> Schedule Date/ Time</span>
                                                </div>
                                                <div className={cx({'hide' : this.state.formData['schedule'] !== 'later'})}>
                                                    <InputGroup>
                                                        <div className="input-group-text">
                                                            <FontAwesomeIcon icon={faCalendarAlt} />
                                                        </div>
                                                        <Controller
                                                            name="camp_schedule"
                                                            control={control}
                                                            rules={{ required: this.state.formData['schedule'] === 'later' && (this.state.formData['scheduleTime'] === undefined || (this.state.formData['scheduleTime'] !== undefined && this.state.formData['scheduleTime'] === '')) ?  "Please choose a Date" : false}}
                                                            render={({...field}) => {
                                                                return (
                                                                    <DatePicker
                                                                        {...field}
                                                                        selected={this.state.scheduleDate}
                                                                        name={"camp_schedule"}
                                                                        id={"camp_schedule"}
                                                                        popperPlacement="top"
                                                                        onChange={(e) => {
                                                                            this.handleDatePickerChange(e);
                                                                        }}
                                                                        minDate={new Date()}
                                                                        autoComplete='off'
                                                                        showTime={{ use12Hours: true, format: "HH:mm a" }}
                                                                        showTimeSelect={true}
                                                                        className={`form-control ${errors.camp_schedule ? 'is-invalid' : ''}`}
                                                                        minTime={formatDate(this.state.scheduleDate,'dd/mm/yyyy') === formatDate(new Date(),'dd/mm/yyyy') ? new Date().getTime() : formatDate(this.state.scheduleDate)}
                                                                        maxTime={setHours(setMinutes(new Date(), 59), 23)} //this set 
                                                                        timeIntervals={30}
                                                                        dateFormat="MMMM d, yyyy h:mm aa"
                                                                        timeCaption="Time" 
                                                                    />
                                                                )
                                                            }
                                                            }
                                                        />
                                                        {errors.camp_schedule && <em className={`error invalid-feedback`}>{errors.camp_schedule.message}</em>}
                                                    </InputGroup>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className={'mt-3 text-center hide'}>
                                        <button ref={this.buttonClickRef} className="btn-wide mb-2 me-2 le-button lePrimaryBtn" size="lg" color="primary">
                                            <span>{buttonTxt}</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Col>
                        <Col md={'4'}>
                            {
                                components.length > 0 &&
                                <PreviewPanel components={components} previewData={this.state.previewData} waComponents={waComponents} formData={this.state.formData} source={ isInbox ? 'template_send' : 'campaign' } />
                            }

                        </Col>
                    </Row>
                </div>

            </Fragment>
        )
    }

    render() {

        let { showLoader, campaignId } = this.state;
        let { isModal, closeModal, isInbox } = this.props;
        let headerTxt = "New Campaign";
        let buttonTxt = "Save & Close";
        let buttonIcon = "pe-7s-diskette";
        if(isModal){
            if(isInbox){
                buttonTxt = "Send Message";
                headerTxt = "Send Message";
                buttonIcon = faPaperPlane;
            }else{
                headerTxt = campaignId === "" ? "New Message" : "Edit Message";
                buttonTxt = campaignId === "" ? "Create Message" : "Update Message";
            }
        } else if (campaignId !== "" && !isModal){
            headerTxt = "Edit Campaign";
            //buttonTxt = "Update Campaign";
        }
        let addonButtons = [];
        if(!isModal) {
            addonButtons = [
                {
                    'buttonTxt': "Send & Set Live",
                    'buttonAction': this.sendCampaign,
                    'buttonOutline': 'success',
                    'buttonIcon': faPaperPlane
                }
            ]
        }

        if(isModal){
            return (
                <Fragment>
                    <CommonHeaderContent
                        isModal={isModal}
                        closeModal={closeModal}
                        buttonAction={this.saveCampaignInfo}
                        buttonIcon={buttonIcon}
                        headerTitle={headerTxt}
                        buttonTxt={buttonTxt}
                        isClassNeeded={false}
                        mainContent={
                            this.getCampaignOperationsContent()
                        } />
                </Fragment>
            );
        }
        return (
            <Common pageTitle={"Campaigns"} showLoader={this.state.showLoader} mainContent={
                <Fragment>
                    <CommonHeaderContent
                        addonButtons={addonButtons}
                        buttonAction={this.saveCampaignInfo}
                        buttonIcon={buttonIcon}
                        headerTitle={headerTxt}
                        buttonTxt={buttonTxt}
                        cancelBtn={true}
                        cancelURL={'campaigns'}
                        mainContent={
                            this.getCampaignOperationsContent()
                        } />
                </Fragment>
            }/>
        )
    }
}

export default CampaignOperations;